import device from 'current-device';
import {CookieService} from '../services/cookie.service';

export class DeviceCategoryDetector {
    static readonly NAME = 'user_device_category';
    public static saveDeviceInCookies(): void {
        if (device?.type) {
            CookieService.setCookie(DeviceCategoryDetector.NAME, device.type, 1);
        }
    }

    public static saveDeviceInStorage(): void {
        if (device?.type) {
            try {
                localStorage.setItem(DeviceCategoryDetector.NAME, device.type);
            } catch {
                try {
                    sessionStorage.setItem(DeviceCategoryDetector.NAME, device.type);
                } catch {
                    // Storage blocked in this context (e.g. Safari with cookies disabled, private mode)
                }
            }
        }
    }

    public static checkIfCookieExists(): boolean {
        if (CookieService.getCookie(DeviceCategoryDetector.NAME)) {
            return true;
        }
        return false;
    }

    public static checkIfSavedInStorage(): boolean {
        let value: string | null = null;

        try {
            value = localStorage.getItem(DeviceCategoryDetector.NAME);
        } catch {
            // localStorage inaccessible
        }

        if (value === null) {
            try {
                value = sessionStorage.getItem(DeviceCategoryDetector.NAME);
            } catch {
                return false;
            }
        }
        return !!value;
    }
}

window.addEventListener('load', () => {
    if (!DeviceCategoryDetector.checkIfCookieExists()) {
        DeviceCategoryDetector.saveDeviceInCookies();
    }
    if (!DeviceCategoryDetector.checkIfSavedInStorage()) {
        DeviceCategoryDetector.saveDeviceInStorage();
    }
});
